let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jQPB7")).then(() => parcelRequire('fayG1'));